import React from 'react';
import Loader from '../components/Loader';
import { useLoader } from '../contexts/LoaderContext';

const GlobalLoader: React.FC = () => {
  const { loading } = useLoader();
  return <Loader loading={loading} />;
};

export default GlobalLoader;
